import styled from 'styled-components';
import { FLINT, OLAF, BATTLESHIP } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Composer = styled.div.withConfig({
  displayName: "MessageComposer__Composer",
  componentId: "sc-1jrcrxs-0"
})(["max-width:100%;background-color:", ";flex-shrink:0;margin:0 16px 16px;border:1px solid ", ";border-radius:28px;padding:8px;[data-test-id='widget-textarea']{min-height:38px !important;}"], OLAF, ({
  $disabled
}) => $disabled ? BATTLESHIP : FLINT);
const Inner = styled.div.withConfig({
  displayName: "MessageComposer__Inner",
  componentId: "sc-1jrcrxs-1"
})(["display:flex;width:100%;align-items:center;justify-content:space-between;flex-wrap:nowrap;gap:4px;"]);
const InputWrapper = styled.div.withConfig({
  displayName: "MessageComposer__InputWrapper",
  componentId: "sc-1jrcrxs-2"
})(["flex:1 1 0px;"]);
const ActionsWrapper = styled.div.withConfig({
  displayName: "MessageComposer__ActionsWrapper",
  componentId: "sc-1jrcrxs-3"
})(["display:flex;flex:0 0 auto;gap:4px;", ""], ({
  children
}) => !children && 'display: none;');
export default function MessageComposer({
  FileUploads = null,
  inputToRender,
  children,
  disabled
}) {
  return /*#__PURE__*/_jsxs(Composer, {
    $disabled: disabled,
    children: [FileUploads, /*#__PURE__*/_jsxs(Inner, {
      children: [/*#__PURE__*/_jsx(InputWrapper, {
        children: inputToRender
      }), /*#__PURE__*/_jsx(ActionsWrapper, {
        children: children
      })]
    })]
  });
}
MessageComposer.displayName = 'MessageComposer';